import { DECORATIONS, type DecorationType } from './bannerOptions';

/**
 * The swatch grid of the Personalized, Task activity and Festival forms. `compact` leaves
 * out the line naming each one's festival; that stays on hover.
 */
export function DecorationPicker({
  value,
  onChange,
  compact = false,
}: {
  value: DecorationType;
  onChange: (d: DecorationType) => void;
  compact?: boolean;
}) {
  return (
    <div className="grid grid-cols-5 gap-2">
      {DECORATIONS.map((d) => (
        <button
          key={d.value}
          type="button"
          aria-pressed={value === d.value}
          onClick={() => onChange(d.value)}
          title={d.hint ? `Typically used for ${d.hint}` : undefined}
          className={`flex flex-col items-center gap-0.5 rounded-lg border-2 text-xs font-medium transition-colors ${
            compact ? 'px-0.5 py-[7px]' : 'px-2 py-2.5'
          } ${
            value === d.value
              ? 'border-primary-500 bg-primary-50 text-primary-700'
              : 'border-gray-200 text-gray-600 hover:bg-gray-50'
          }`}
        >
          <span className="text-lg leading-5">{d.emoji}</span>
          <span className="text-center leading-[14px]">{d.label}</span>
          {/* Which festival each one is for — "Rakhi" vs "Lamps" isn't obvious. */}
          {!compact && d.hint && <span className="text-[10px] leading-tight text-gray-400">{d.hint}</span>}
        </button>
      ))}
    </div>
  );
}
